import { RootState } from '../../store';

export const getPrioritySelector = (state: RootState) => state?.priorityReducer?.priority;
